import firebase from "../helper/firebase";
import _ from "lodash";

const initialState = {
  selectionStages: {},
  selectionStagesLoading: true,

  applicants: {},
  applicantsLoading: true
};

//Actions
const UNAUTHENTICATED = "GlobalState/UNAUTHENTICATED";
const SET_SNACK = "GlobalState/SET_SNACK";
const GET_SELECTIONSTAGES = "AdminState/GET_SELECTIONSTAGES";
const GET_APPLICANTS = "AdminState/GET_APPLICANTS";

const GET_JOB = "JobState/GET_JOB";
export function getJobListener(jid) {
  return (dispatch, getState) => {
    let jobs = getState().job;
    if (!jobs[jid]) {
      firebase
        .firestore()
        .collection("jobs")
        .doc(jid)
        .onSnapshot(snap => {
          if (!!snap.data()) {
            jobs[jid] = snap.data();
          }
          dispatch({ type: GET_JOB, payload: jobs });
        });
    }
  };
}

export function getSelectionStages() {
  return (dispatch, getState) => {
    let { selectionStages } = getState().admin;
    if (_.isEmpty(selectionStages)) {
      getSelectionStagesPromise()
        .then(data => dispatch({ type: GET_SELECTIONSTAGES, payload: data }))
        .catch(error => setSnack(true, error));
    }
  };
}

function getSelectionStagesPromise() {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref(`selectionStages`)
      .once("value")
      .then(selectionStages => resolve(selectionStages.val()))
      .catch(error => {
        reject(error);
      });
  });
}

export function getApplicants(jid) {
  return (dispatch, getState) => {
    let { applicants } = getState().admin;
    if (!applicants[jid]) {
      getApplicantsPromise(jid)
        .then(data => dispatch({ type: GET_APPLICANTS, payload: data, jid }))
        .catch(error => setSnack(true, error));
    }
  };
}

function getApplicantsPromise(jid) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref(`applications/${jid}`)
      .once("value")
      .then(applicants => resolve(applicants.val()))
      .catch(error => reject(error));
  });
}

export function setSnack(snackStatus, snackMessage) {
  return (dispatch, getState) => {
    let snack = { snackStatus, snackMessage };
    dispatch({ type: SET_SNACK, payload: snack });
  };
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SELECTIONSTAGES:
      return {
        ...state,
        selectionStages: action.payload,
        selectionStagesLoading: false
      };

    case GET_APPLICANTS:
      let applicants = state.applicants;
      applicants[action.jid] = action.payload;
      return {
        ...state,
        applicants,
        applicantsLoading: false
      };

    case UNAUTHENTICATED:
      console.log("admin/UNAUTHENTICATED");
      return {
        ...initialState,
        authLoading: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/AdminReducer.js